const M3_BASE_PATH = "/tools/proxy-app/m3";
const emailVerifiedParam = "emailVerified";

const ROUTES = {
  sign_in_url: `${M3_BASE_PATH}/signin`,
  sign_up_url: `${M3_BASE_PATH}/signup`,
  recover_password_url: `${M3_BASE_PATH}/recover_password`,
  reset_password_url: `${M3_BASE_PATH}/reset_password`,
}

class SignInForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');

    this.formAction = this.form.action;
    this.form.action = "";

    this.formOnSubmit = this.form.onsubmit;
    this.form.onsubmit = "";

    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.submitButton = this.form.querySelector("button")
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.submitButton.disabled = true;
    this.submitButton.textContent = this.submitButton.dataset.disableWith;
    let body = {
      email: this.form["customer[email]"].value,
      password: this.form["customer[password]"].value,
      email_verification_enabled: m3_shopify_email_verification_enabled
    };
    
      grecaptcha.execute('6Lc2G28hAAAAABHXlK2rePZqiFGtasO7RrUbQirb', {action: 'login'})
        .then(token => {
          let recaptchaBody = JSON.stringify({
            ...body, recaptcha_token: token
          });
          this.signIn(recaptchaBody);
        });
    
  }

  signIn(body) {
    fetch(ROUTES.sign_in_url, { ...fetchConfig('json'), body })
      .then((response) => { 
        if (response.ok || response.status === 401) {
          return response.json();
        } else {
          throw new Error('Something went wrong');
        }})
      .then((parsedState) => {
        if (parsedState.pendingEmailVerification === true){
          this.form.action = this.formAction;
          this.form.onsubmit = this.formOnSubmit;
          this.form.submit();
        } else if (parsedState.success) {
          Cookies.set('ACCESS_TOKEN', parsedState.member.accessToken)
          Cookies.set('REFRESH_TOKEN', parsedState.member.refreshToken)
          Cookies.set('ID_TOKEN', parsedState.member.idToken)
          window.location.replace(parsedState.multipass_url);
        } else if (parsedState?.errorResponse?.errorDescription) {
          this.addError(parsedState?.errorResponse?.errorDescription)
        } else {
          this.showGenericError()
        }
      })
      .catch((_error) => {
        this.showGenericError()
      })
  }

  addError(message) {
    this.submitButton.disabled = false
    this.submitButton.textContent = this.submitButton.dataset.text;
    this.form.querySelector("#login-form-error-custom").textContent = message
    this.form.querySelector("#login-form-error-custom").classList.remove("hidden")
    this.form.querySelector("#login-form-error").classList.add("hidden")
    document.dispatchEvent(new Event('popover:update'))
  }

  showGenericError() {
    this.form.querySelector("button").disabled = false;
    this.submitButton.textContent = this.submitButton.dataset.text;
    this.form.querySelector("#login-form-error").classList.remove("hidden")
    this.form.querySelector("#login-form-error-custom").classList.add("hidden")
    document.dispatchEvent(new Event('popover:update'))
  }
}

class SignUpForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');

    this.formAction = this.form.action;
    this.form.action = "";

    this.formOnSubmit = this.form.onsubmit;
    this.form.onsubmit = "";
    
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.submitButton = this.form.querySelector("button")
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.submitButton.disabled = true
    this.submitButton.textContent = this.submitButton.dataset.disableWith;
    let body = JSON.stringify({
      last_name: this.form["customer[last_name]"].value,
      first_name: this.form["customer[first_name]"].value,
      email: this.form["customer[email]"].value,
      password: this.form["customer[password]"].value,
      accepts_marketing: this.form["customer[accepts_marketing]"].checked,
      email_verification_enabled: m3_shopify_email_verification_enabled
    });

    this.signUp(body);
  }

  signUp(body) {
    fetch(ROUTES.sign_up_url, { ...fetchConfig('json'), body })
      .then((response) => { 
        if (response.ok || response.status === 401) {
          return response.json();
        } else {
          throw new Error('Something went wrong');
        }})
      .then((parsedState) => {
        if (parsedState.success) {
          if(m3_shopify_email_verification_enabled){
            this.form.action = this.formAction;
            this.form.onsubmit = this.formOnSubmit;
            this.form.submit();
          }else{
            Cookies.set('ACCESS_TOKEN', parsedState.member.accessToken)
            Cookies.set('REFRESH_TOKEN', parsedState.member.refreshToken)
            Cookies.set('ID_TOKEN', parsedState.member.idToken)
            window.location.replace(parsedState.multipass_url);
          }
        } else {
          this.addError(parsedState?.errorResponse?.errorDescription)
        }
      })
      .catch((_error) => {
        this.addError("Cannot process the request") // TODO: Define system error message
      })
  }

  addError(message) {
    this.submitButton.disabled = false
    this.submitButton.textContent = this.submitButton.dataset.text;
    this.form.querySelector("#register-form-error").textContent = message
    this.form.querySelector("#register-form-error").classList.remove("hidden")
    document.dispatchEvent(new Event('popover:update'))
  }
}

class RecoverPasswordForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.submitButton = this.form.querySelector("button")
    this.submitButton.addEventListener("click", this.onSubmitHandler.bind(this));
    this.errorMessageContainer = this.form.querySelector("#recovery-form-error")
    this.successMessageContainer = this.form.querySelector("#recovery-form-success")
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.form.querySelector("button").disabled = true;
    this.form.querySelector("button").textContent = this.submitButton.dataset.disableWith;
    const recoverRequest = this.form["customer[otp]"].value === ""
    let body = {
      email: this.form["customer[recover_email]"].value,
      email_verification_enabled: m3_shopify_email_verification_enabled,

      ...!recoverRequest && {
        password: this.form["customer[password]"].value,
        otp: this.form["customer[otp]"].value,
      }
    };

    if (!recoverRequest) {
      
        grecaptcha.execute('6Lc2G28hAAAAABHXlK2rePZqiFGtasO7RrUbQirb', { action: 'login' })
          .then(token => {
            let recoverBody = JSON.stringify({
              ...body, recaptcha_token: token
            });
            this.resetPassword(recoverBody);
          });
      
    } else {
      
        grecaptcha.execute('6Lc2G28hAAAAABHXlK2rePZqiFGtasO7RrUbQirb', { action: 'login' })
          .then(token => {
            let recoverBody = JSON.stringify({
              ...body, recaptcha_token: token
            });
            this.recoverPassword(recoverBody);
          });
      
    }
  }

  showError(errorMessage) {
    if(!errorMessage)
    errorMessage = "Something went wrong. Please try again later or reach out our support"

    this.form.querySelector("#recovery-form-error").textContent = errorMessage;
    this.form.querySelector("#recovery-form-error").classList.remove("hidden")
    this.form.querySelector("#recovery-form-success").classList.add("hidden")
    document.querySelector("#recover-form-email-unverfied").classList.add("hidden")
  }

  showSuccess() {
    document.querySelector("#recover-form-email-unverfied").classList.add("hidden")
    this.form.querySelector("#recovery-form-error").classList.add("hidden")
    this.form.querySelector("#recovery-form-success").classList.remove("hidden")
  }

  showPendingEmailVerification () {
    this.form.querySelector("#recovery-form-error").classList.add("hidden")
    this.form.querySelector("#recovery-form-success").classList.add("hidden")
    document.querySelector("#recover-form-email-unverfied").classList.remove("hidden")
  }

  recoverPassword(body) {
    fetch(ROUTES.recover_password_url, { ...fetchConfig('json'), body })
      .then((response) => { 
        if (response.ok || response.status === 401) {
          return response.json();
        } else {
          throw new Error('Something went wrong');
        }})
      .then((parsedState) => {
        this.submitButton.disabled = false;
        if (parsedState.pendingEmailVerification === true){
          this.submitButton.textContent = this.submitButton.dataset.text;
          this.showPendingEmailVerification();
        } else if (parsedState.success === true) {
          this.submitButton.textContent = this.submitButton.dataset.resetPasswordText;

          this.showSuccess();

          this.form["customer[otp]"].parentNode.classList.remove("hidden")
          this.form["customer[otp]"].disabled = false

          this.form["customer[password]"].parentNode.classList.remove("hidden")
          this.form["customer[password]"].disabled = false
        } else {
          this.submitButton.textContent = this.submitButton.dataset.text;

          let customErrorMessage = null;
          switch(parsedState.errorResponse.errorCode){
            case "9999":
              customErrorMessage = "Attempt limit exceeded, please try after some time";
              break;
            case "1012":
              customErrorMessage = "If email is registered, you will get a reset link.";
            default:
              break;
          }
          
          this.showError(customErrorMessage);
        }
      })
      .catch((_error) => {
        this.successMessageContainer.textContent = "If this account exists an email will be sent."
        this.successMessageContainer.classList.remove("hidden")

        this.submitButton.disabled = false;
        this.submitButton.textContent = this.submitButton.dataset.text;
      })
  }

  resetPassword(body) {
    fetch(ROUTES.reset_password_url, { ...fetchConfig('json'), body })
      .then((response) => { 
        if (response.ok || response.status === 401) {
              return response.json();
        } else {
          throw new Error('Something went wrong');
        }})
      .then((parsedState) => {
        if (parsedState.pendingEmailVerification === true){
          this.submitButton.textContent = this.submitButton.dataset.resetPasswordText;
          this.showPendingEmailVerification();
        } else if (parsedState.success === true) {
          Cookies.set('ACCESS_TOKEN', parsedState.member.accessToken);
          Cookies.set('REFRESH_TOKEN', parsedState.member.refreshToken);
          Cookies.set('ID_TOKEN', parsedState.member.idToken);
          window.location.replace(parsedState.multipass_url);
        } else {
          this.submitButton.disabled = false;
          this.form.querySelector("#recovery-form-success").classList.add("hidden")

          let customErrorMessage = parsedState["errorResponse"]["errorDescription"];
          switch(parsedState.errorResponse.errorCode){
            case "9999":
              customErrorMessage = "Attempt limit exceeded, please try after some time";
              break;
            default:
              break;
          }

          this.form.querySelector("#recovery-form-error").textContent = customErrorMessage
          this.form.querySelector("#recovery-form-error").classList.remove("hidden")
        }
        this.submitButton.disabled = false;
        this.submitButton.textContent = this.submitButton.dataset.resetPasswordText;
      })
      .catch((_error) => {
        // TODO: specify error message here
        this.submitButton.disabled = false;
        this.submitButton.textContent = this.submitButton.dataset.resetPasswordText;
      })
  }
}
document.addEventListener('DOMContentLoaded', function () {
  customElements.define('m3-recover-password', RecoverPasswordForm);
  customElements.define('m3-signup', SignUpForm);
  customElements.define('m3-signin', SignInForm);

  document.addEventListener('click',function(e){
    if(e.target && e.target.getAttribute('href') == '/account/logout'){
          handleLogoutClick(e);
     }
  });

  const params = new URLSearchParams(window.location.search)

  if(params.has(emailVerifiedParam))
  document.querySelector("#login-form-success-email-verfied").classList.remove("hidden")

  const logoutButton = document.querySelector('a[href^="/account/logout"]');

  if(isCustomerLoggedIn && readCookie('ACCESS_TOKEN') === null){
    clearCookies();
    fetch(logoutButton.href).then(() => window.location.href = `/account/login?${m3_shopify_email_verification_enabled ? emailVerifiedParam : "invalidToken"}`);
  }
})

function clearCookies(){
  Cookies.remove('ACCESS_TOKEN');
  Cookies.remove('REFRESH_TOKEN');
  Cookies.remove('ID_TOKEN');
}

// clear cookies and logout
function handleLogoutClick(event) {
  event.preventDefault();
  clearCookies();
  window.location.href = event.target.getAttribute('href');
}
